import {COUNTRIES} from './countriesActionTypes';

export function getCountries() {
  return {
    type: COUNTRIES.GET_COUNTRIES,
    payload: {
      client: 'default',
      request: {
        url: `location/countries`,
        method: 'get'
      }
    }
  };
}
export function getCities() {
  return {
    type: COUNTRIES.GET_CITIES,
    payload: {
      client: 'default',
      request: {
        url: `location/cities`,
        method: 'get'
      }
    }
  };
}

export function addCountry(data) {
  return {
    type: COUNTRIES.ADD_COUNTRY,
    payload: {
      client: 'default',
      request: {
        url: `location/countries`,
        method: 'post',
        data
      }
    }
  };
}

export function addCity(data) {
  return {
    type: COUNTRIES.ADD_CITY,
    payload: {
      client: 'default',
      request: {
        url: `location/cities`,
        method: 'post',
        data
      }
    }
  };
}

export function editCountry(id, data) {
  return {
    type: COUNTRIES.ADD_COUNTRY,
    payload: {
      client: 'default',
      request: {
        url: `location/countries/${id}`,
        method: 'post',
        data: {
          name: data
        }
      }
    }
  };
}

export function editCity(id, data) {
  return {
    type: COUNTRIES.ADD_CITY,
    payload: {
      client: 'default',
      request: {
        url: `location/cities/${id}`,
        method: 'post',
        data: {
          name: data
        }
      }
    }
  };
}
